module.exports = __webpack_public_path__ + "img/event.b611128a.svg";